import { render, staticRenderFns } from "./disabledPaymentBusinessPage.vue?vue&type=template&id=7fb4167e&scoped=true&"
import script from "./disabledPaymentBusinessPage.vue?vue&type=script&lang=js&"
export * from "./disabledPaymentBusinessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb4167e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VImg,VSheet})
